// extracted by mini-css-extract-plugin
module.exports = {"add-app-capabilities-container":"KQrJT57OgLdH417+nJmLYA=="};